import Specification from "./Specification";

export default Specification;
